module.exports = __webpack_public_path__ + "img/attrSec_bg.47b578cd.png";